import TimeDuration from './timeFormats';
import Dictionary from './dictionary';

// Nameless airlines are dropped rather than interpolated: the BFF names these from a catalogue and
// soft-fails to un-named flights when that lookup is unavailable, and a bare `${airline.name}` then
// rendered the literal string "undefined" as the airline — truthy, so no caller's guard caught it.
const listOfAirlines = (operatingAirlines = []) => {
  return operatingAirlines
    .map((airline) => airline?.name)
    .filter(Boolean)
    .join(', ');
};

const marketingAirlines = (flightSegments = []) => {
  const seen = new Map();
  flightSegments.forEach(({ marketingAirline }) => {
    if (marketingAirline?.code && !seen.has(marketingAirline.code)) {
      seen.set(marketingAirline.code, { name: marketingAirline.name });
    }
  });
  return [...seen.values()];
};

const numberOfStops = (segments, renderContent) => {
  switch (true) {
    case segments.length === 2:
      return `${segments.length - 1} ${renderContent(
        Dictionary.airStopsNumberSingleLabel.key,
        Dictionary.airStopsNumberSingleLabel.defaultValue,
      )}`;
    case segments.length > 2:
      return `${segments.length - 1} ${renderContent(
        Dictionary.airStopsNumberLabel.key,
        Dictionary.airStopsNumberLabel.defaultValue,
      )}`;
    default:
      return renderContent(Dictionary.airNonstopLabel.key, Dictionary.airNonstopLabel.defaultValue);
  }
};

const countStopsLabel = (segments, label) => {
  if (segments.length > 1) {
    return ` ${label || 'in '} 
      ${segments
        .map((segment, segmentIndex) => {
          return segmentIndex < segments.length - 1
            ? `${segment.arrival.airport.code}${segmentIndex !== segments.length - 2 ? ', ' : ''}`
            : ``;
        })
        .join('')}`;
  }
  return '';
};

const countStopsLabelBig = (flightInfo) => {
  switch (true) {
    case flightInfo.flightSegments.length === 2:
      return `${TimeDuration(flightInfo.flightSegments[0].layoverMins)} ${
        flightInfo.flightSegments[0].arrival.airport.code
      }`;
    case flightInfo.flightSegments.length > 2:
      return `${flightInfo.flightSegments
        .map((segment, segmentIndex) => {
          return segmentIndex < flightInfo.flightSegments.length - 1
            ? `${segment.arrival.airport.code}${
                segmentIndex !== flightInfo.flightSegments.length - 2 ? ', ' : ''
              }`
            : ``;
        })
        .join('')}`;
    default:
      return ``;
  }
};

export default {
  listOfAirlines,
  marketingAirlines,
  numberOfStops,
  countStopsLabel,
  countStopsLabelBig,
};
